<template>
	<v-app theme="dark" style="background-color: #eeeeee">
		<v-app-bar app color="#EEEEEE" elevation="0" class="px-4 py-6">
			<div class="d-flex align-center" style="cursor: pointer;">
				<a href="https://www.orixe.eu/" target="_blank">
					<v-img
						class="mt-0 pt-0"
						alt="Orixe Logo"
						:src="require('../../assets/Logo_teal_stacked_0.25x-removebg-preview.png')"
						width="250"
					/>
				</a>
			</div>
		</v-app-bar>
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="12" md="6">
						<v-card class="elevation-12" style="padding: 5px;">
							<v-toolbar-title>
								<v-img class="mx-auto mt-3"
									:src="logoUrl" width="200" />
							</v-toolbar-title>
							<v-card-text class="text-h6 black--text">

								{{ clientname }} has invited you to the <a href="https://orixe.tech"
									target="_blank">orixe.tech</a>
								platform. Orixe is a digital platform for auditing suppliers and supply chain
								traceability.
							</v-card-text>
							<v-form>
								<v-card-text>
									<v-text-field id="invitationcode" label="Invitation Code" name="Invitation Code"
										prepend-icon="fas fa-envelope-open-text" v-model="tmpInvitationCode">
									</v-text-field>
									<p class="ml-8 pt-0">Orixe requires an invitation code to register.</p>
								</v-card-text>
								<div class="container" style="font-size: 18px; margin-bottom: 5%;">
									<form @submit.prevent="checkcode" style="margin-left: 35px;">
										<div class="form-group form-check">
											<input type="checkbox" v-model="user.accept" id="accept"
												class="form-check-input">
											<label class="form-check-label" for="accept"> Accept 
												<a href="/License.pdf" target="_blank" class="black--text">terms and conditions</a></label>
											
										</div>
										<div style="margin-top: 40px;">
											<v-btn @click="checkcode" color="orangeButton" outlined style="height: 40px; font-size: 16px;"><v-icon left small>fas fa-arrow-right</v-icon>Continue to fill out</v-btn>
											<!-- <v-btn @click="checkcode" color="primary" style="width: 150px; height: 40px; font-size: 16px; margin-left: 4%;">Register</v-btn> -->
										</div>
										<div class="form-group">
											{{ '' }}
										</div>
									</form>
								</div>

								<v-card-actions style="margin-left: 35px; font-size: 18px;">
									<p>Already have an account?&nbsp;&nbsp;&nbsp;<b>Go to <router-link
												to="/login">orixe.tech/login</router-link></b>
									</p>
								</v-card-actions>
							</v-form>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<test-error />
		<orixe-footer />
	</v-app>
</template>

<script>
import router from "../../router"
import InvitationcodeAPI from "../../api/connections/invitationcodes"
import LoadingState from "../../consts/LoadingState"
import { mapActions, mapState } from "vuex"

export default {
	name: "Invite",
	data() {
		return {
			logoUrl: null,
			clientname: null,
			url: {
				path: "/knowledge",
				query: {
					article: "Registration, Login, Inviting Suppliers",
					doc: "register-login"
				}
			},
			tmpInvitationCode: null,
			user: {
				accept: false
			}
		}
	},
	mounted() {
		this.tmpInvitationCode = this.$route.query.code
		this.getclientname()
	},
	methods: {
		checkcode() {
			if (this.user.accept == true) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_START_LOADING,
					null,
					{ root: true }
				)
				InvitationcodeAPI.valid(this.tmpInvitationCode)
					.then((result) => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							{ root: true }
						)
						if (result) {
							this.invitationcode = this.tmpInvitationCode
							router.push("/register")
						}
					})
					.catch((error) => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							error,
							{ root: true }
						)
					})
			} else if (this.user.accept == false && this.tmpInvitationCode != null) {
				alert("Accept terms and conditions to make a account.")
			} else {
				alert("Invitaiton code is needed.")
			}

		},
		/* checkguest() {
			if (this.user.accept == true) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_START_LOADING,
					null,
					{ root: true }
				)
				InvitationcodeAPI.valid(this.tmpInvitationCode)
					.then((result) => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							{ root: true }
						)
						if (result) {
							this.invitationcode = this.tmpInvitationCode
							router.push("/guestRegistration")
						}
					})
					.catch((error) => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							error,
							{ root: true }
						)
					})
			} else if (this.user.accept == false && this.tmpInvitationCode != null) {
				alert("Accept terms and conditions to make a account.")
				console.log(this.tmpInvitationCode.length)
			} else {
				alert("Invitaiton code is needed.")
			}

		}, */
		getclientname() {
			InvitationcodeAPI.getClientdata(this.tmpInvitationCode)
				.then((result) => {
					this.clientname = result[0]
					this.logoUrl = result[1]
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		...mapActions("connections/invitationcodes", ["setInvitationCode"]),
	},
	computed: {
		...mapState("connections/invitationcodes", {
			_invitationcode: (state) => state.invitationcode,
		}),
		invitationcode: {
			get() {
				return this._invitationcode
			},
			set(c) {
				this.setInvitationCode({ invitationcode: c })
			},
		},
	},
}
</script>